export { default } from './OriMuiThemeProvider';
export * from './OriMuiThemeProviderProps';